/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: de87da16b2ec
 */

import * as z from "zod";
import { UploadMapping, UploadMapping$zodSchema } from "./uploadmapping.js";

/**
 * List response for upload mappings.
 */
export type UploadMappingListResponse = {
  mappings: Array<UploadMapping>;
  total_entries: number;
  next_cursor?: string | undefined;
};

export const UploadMappingListResponse$zodSchema: z.ZodType<
  UploadMappingListResponse
> = z.object({
  mappings: z.array(UploadMapping$zodSchema).describe(
    "Array of upload mapping objects.",
  ),
  next_cursor: z.string().optional().describe(
    "Cursor for getting the next page of results.",
  ),
  total_entries: z.int().describe("Total number of mappings."),
}).describe("List response for upload mappings.");
